import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { AutofocusService } from '../services/autofocus/autofocus.service';
import { Focusable } from '../services/autofocus/focusable';

@Directive({
  selector: '[bomAutofocusable]',
})
export class AutofocusableDirective implements AfterViewInit, OnInit {
  private focusable: Focusable;

  constructor(
    private el: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    private viewContainerRef: ViewContainerRef,
    private autofocusService: AutofocusService
  ) {}

  ngOnInit() {
    // This is a hacky way of getting a hold of the host component as an interface, which
    // is not usually doable
    const componentView = this.getComponent(this.viewContainerRef);
    if (componentView) {
      this.focusable = componentView as Focusable;
    }
  }

  getComponent(viewContainerRef: any) {
    const i = viewContainerRef._hostTNode.directiveStart;
    const component = viewContainerRef._hostLView[i];

    // If component has property "setFocus" then we assume it implements the Focusable interface
    const isFocusable = 'setFocus' in component;

    return isFocusable ? component : null;
  }

  ngAfterViewInit(): void {
    if (this.focusable) {
      this.autofocusService.requestFocus(this.focusable);
    } else {
      this.autofocusService.requestFocus(this.el);
    }

    // We need to force change detection after setting focus
    this.changeDetectorRef.detectChanges();
  }
}
